/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/location_medium'
export default icon
